import { Component } from '@angular/core';

@Component({
  selector: 'app-unit-box',
  standalone: true,
  imports: [],
  templateUrl: './unit-box.component.html',
  styleUrl: './unit-box.component.scss'
})
export class UnitBoxComponent {

}
